import { render, staticRenderFns } from "./VContainerPrincipal.vue?vue&type=template&id=254aa90d"
var script = {}
import style0 from "./VContainerPrincipal.vue?vue&type=style&index=0&id=254aa90d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports